import React, {useCallback, useEffect, useState} from 'react'
import {CategoryType, Setting, webData} from "./setting";
import {ReactWebengage} from 'react-webengage'

export const strUrl = (v:any)=>{
    if(v){
        return encodeURIComponent(v.replaceAll(" ","_").replaceAll("'","").replaceAll('"',""))
    }else{
        return ""
    }
}

export const numToStr = (n:number)=>{
    const all =[
        "الأولى",
        "الثانية",
        "الثالثة",
        "الرابعة",
        "الخامسة",
        "السادسة",
        "السابعة",
        "الثامنة",
        "التاسعة",
        "العاشرة"
    ]
    return all[n]
}

export const IsMobile =()=>{
    const handleWindowSizeChange = ()=> {
        return  window.innerWidth;
    }
    window.addEventListener('resize', handleWindowSizeChange);
    return (handleWindowSizeChange() <= 768) ? true : false;
}

export const details = (v:any,work:number)=>{
    let str = ""
    let append = "[...]"

    if(v.split(" ").length > work){
        for (let i = 0; i < work ; i++) {
            str += v.split(" ")[i]+" ";
        }
        str = str + append
    }else{
        str = v
    }
    return str
}

export const getUrl = (v:any)=>{
    let url = ""
    if(v.url){
        url =v.url
    }else{
        url = CategoryType[v.type].path + (CategoryType[v.type].id == true ? v.id : "") + (CategoryType[v.type].path != "./" ? "/"+strUrl(v.title) : "" )
    }
    return url
}
export function useInViewport(): { isInViewport: boolean; ref: React.RefCallback<HTMLElement> } {
    const [isInViewport, setIsInViewport] = useState(false);
    const [refElement, setRefElement] = useState<HTMLElement | null>(null);

    const setRef = useCallback((node: HTMLElement | null) => {
        if (node !== null) {
            setRefElement(node);
        }
    }, []);

    useEffect(() => {
        if (refElement && !isInViewport) {
            const observer = new IntersectionObserver(
                ([entry]) => entry.isIntersecting && setIsInViewport(true)
            );
            observer.observe(refElement);

            return () => {
                observer.disconnect();
            };
        }
    }, [isInViewport, refElement]);

    return { isInViewport, ref: setRef };
}

export  function support_webp()
{
    var elem = document.createElement('canvas');

    if (!!(elem.getContext && elem.getContext('2d')))
    {
        return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
    }
    else
    {
        return false;
    }
}

export let setTitle = (v:any)=>{
    window.document.title = Setting.systemName + " - " + v.title
}

export let getLocation = (v:any)=>{
    let location = ""
    if(v){
        location = v.replaceAll("/","").replaceAll(".","")
    }
    return location
}
export const youtube_id = (url:any)=>{
    if(url){
        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        var match = url.match(regExp);
        return (match&&match[7].length==11)? match[7] : false;
    }else{
        return ""
    }

}
export function newLine(text:string):React.ReactNode {
    return  text.replaceAll("\n","<br />");
}
export const isAuth = ()=>{
    // Ensure webData.User.token is initialized from localStorage if it exists
    if (!webData.User.token && localStorage.getItem("token")) {
        webData.User.token = localStorage.getItem("token");
    }

    if(webData.User.token != null && webData.User.token != "" && webData.User.token != "null"){
        return true
    }else{
        return false
    }
}
export const handleReset = () => {
    Array.from(document.querySelectorAll("input")).forEach(
        input => (input.value = "")
    );
    Array.from(document.querySelectorAll("textarea")).forEach(
        input => (input.value = "")
    );
};

export const CheckValue = (key:any)=> {
    return (localStorage.getItem(key) != "null"  ? localStorage.getItem(key) :  "") as string
}
export const clearLogin = ()=>{
    webData.User = []
    localStorage.clear()
}

export const checkError = (obj:any) => {
    let error = false
    Object.entries(obj).map((v:any,k:any)=>{
        if(v[1] == false){
            error = true
        }
    })
    return error
}

export const catTree  = (treeArray:any, parentId = 0) =>{
    const output:any = [];
    treeArray.map((node:any,k:any)=>{
        if(parseInt(node.catid) == parentId && node.show_header == "1"){
            const children = catTree(treeArray,node.id)
            if(children ){
                node.children = children
                node.child = children.length
            }else{
                node.child = 0
            }
            output.push(node)
        }
    })
    return output
}

export const getDay = (dateFormat:any)=>{
    let [y, m, d] = dateFormat.split("-");
    const date = new Date(y, m - 1, d)
    const month = date.toLocaleString("ar", {month:"long"})
    const day = date.toLocaleString("ar", {weekday:"long"})
    const dayNum = date.toLocaleString("ar", {day:"numeric"})
    const year = date.toLocaleString("ar", {year:"numeric"})
    const short = date.toLocaleString("ar", {month:"2-digit",day:"2-digit"})
    return {month:month,day:day,year:year,dayNum:dayNum,short:short}
}

export const getParent = (treeArrays:any, parentId = 0) =>{
    const outputs:any = [];
    treeArrays.map((node:any,k:any)=>{
        if(parseInt(node.id) == parentId){
            const children = getParent(treeArrays,node.catid)
            if(children.length > 0 ){
                node.parent = children
            }
            outputs.push(node)
        }
    })
    return outputs
}

function getMonday(d:any) {
    d = new Date(d);
    var day = d.getDay(), diff = d.getDate() - day + (day == 0 ? -6:1);
    return new Date(d.setDate(diff));
}

export function getDate(d:Date,format:boolean){
    if(format){
        return d.toLocaleString("en",{year:"numeric"})+"-"+d.toLocaleString("en",{month:"2-digit"})+"-"+d.toLocaleString("en",{day:"2-digit"})
    }else{
        return d.toLocaleString("en",{year:"numeric"})+""+d.toLocaleString("en",{month:"2-digit"})+""+d.toLocaleString("en",{day:"2-digit"})
    }
}

export function getdayName(d:any) {
    const date = getDay(d.split('T')[0]);
    return date.day + ", " +date.dayNum + " " + date.month + " " + date.year
}

export const GetNextWeekStart = (format:boolean)=> {
    const first = getMonday(new Date())
    return getDate(new Date(new Date().setDate(first.getDate() + 7)),format)
}

export const GetTommoro = (format:boolean)=> {
    const first = new Date()
    return getDate(new Date(new Date().setDate(first.getDate() + 1)),format)
}

export const GetNextWeekEnd = (format:boolean)=> {
    const first = getMonday(new Date())
    return getDate(new Date(new Date().setDate(first.getDate() + 13)),format)
}

export const GetCurrWeekStart = (format:boolean)=> {
    const first = getMonday(new Date())
    return getDate(new Date(first),format)
}

export const GetCurrWeekEnd = (format:boolean)=> {
    const first = getMonday(new Date())
    return getDate(new Date(new Date().setDate(first.getDate() + 6)),format)
}

